// anthor:PuZeHui
<template>
  <div class="ele-wrap">
    <div class="wraps">
      <div class="select-box">
        <div class="select-margin">
          <el-select v-model="seachOption.client" clearable placeholder="请选择">
            <el-option v-for="item in allCompany" :key="item.value" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="select-margin">
          <el-date-picker v-model="seachOption.time" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy/MM/dd">
          </el-date-picker>
        </div>
        <div class="select-margin">
          <el-select v-model="seachOption.status" placeholder="请选择合同状态">
            <el-option v-for="item in status" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <el-button type="primary" size="small" @click="seachData">查询</el-button>
      </div>
      <div class="table-box">
        <el-table :data="tableData" border stripe fit  highlight-current-row  style="width: 100%">
          <el-table-column label="合同名称" prop="name" min-width="200"></el-table-column>
          <!-- <el-table-column label="合同编号" prop="id"></el-table-column> -->
          <el-table-column label="服务提供方公司" prop="serviceProviderCompanyName"  min-width="200"></el-table-column>
          <el-table-column label="服务提供方公司办理人" prop="serviceProviderTransactorNickname"  min-width="200"></el-table-column>
          <el-table-column label="客户公司" prop="clientCompanyName"  min-width="200"></el-table-column>
          <el-table-column label="客户公司办理人" prop="clientTransactorNickname"  min-width="130"></el-table-column>
          <el-table-column label="合同状态"  min-width="100">
            <template slot-scope="scope">
              <span>{{
                status.find(c => c.value == scope.row.status)["label"]
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="签订时间" prop="signingTime" min-width="150">
            <template slot-scope="scope">
              {{ scope.row.signingTime.substr(0, 11) }}
            </template>
          </el-table-column>
          <el-table-column label="开始时间" prop="startTime" min-width="120">
            <template slot-scope="scope">
              {{ scope.row.startTime.substr(0, 11) }}
            </template>
          </el-table-column>
          <el-table-column label="结束时间" prop="endTime" min-width="120">
            <template slot-scope="scope">
              {{ scope.row.endTime.substr(0, 11) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="120">
            <template slot-scope="scope">
              <span class="operatiing" @click="openDetails(scope.row)">详情</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 详情 -->
    <detail-drawer ref="detailDrawer" v-if="detailDrawerVisible" :status='status' :taskList='taskList' :cycleList='cycleList'></detail-drawer>
  </div>
</template>

<script>
import detailDrawer from './detailDrawer.vue'
import contractHttpSet from "./httpClass";
export default {
  components: {
    detailDrawer
  },
  data () {
    return {
      detailDrawerVisible: false,
      detail: "",
      cycleList: [
        { label: "无", value: 0 },
        { label: "周(1/4月)", value: 1 },
        { label: "月(1月)", value: 2 },
        { label: "季度(3月)", value: 3 },
        { label: "半年(6月)", value: 4 },
        { label: "年(12月)", value: 5 }
      ],
      measureList: "",
      serversList: [],
      clientServersList: [],
      contractHttpSet: "",
      allCompany: "",
      status: [
        { label: "全部状态", value: -1 },
        { label: "生效中", value: 1 },
        { label: "正常终止", value: 2 },
        { label: "协商终止", value: 3 }
      ],
      taskList: [
        { label: "站点改造", value: 1 },
        { label: "抢修", value: 2 },
        { label: "试验", value: 3 },
        { label: "巡检", value: 4 },
        { label: "其他", value: 5 }
      ],
      contractForm: {
        name: "",
        signingTime: "",
        startTime: "",
        endTime: "",
        serviceProviderCompanyId: "",
        serviceProviderTransactorId: "",
        clientCompanyId: "",
        clientTransactorId: "",
        services: [{ type: "", params: { measures: [], cycle: "", times: "" } }]
      },
      formLabelWidth: "120px",
      dialogFormVisible: false,
      detailDrawer: false,
      seachOption: {
        client: "",
        status: -1,
        time: []
      },

      clientList: [{ label: "全部客户", value: 0 }],
      tableData: []
    };
  },
  computed: {},
  watch: {},
  methods: {
    async seachData () {
      this.tableData = await this.contractHttpSet.getListElectricOperationsContractForClient(
        this.seachOption.client,
        this.seachOption.time[0],
        this.seachOption.time[1],
        this.seachOption.status
      );
    },
    async saveData () {
      this.contractForm.startTime = this.contractForm.value1[0];
      this.contractForm.endTime = this.contractForm.value1[1];
      let res = await this.contractHttpSet.addElectricOperationsContract(
        this.contractForm.name,
        this.contractForm.signingTime,
        this.contractForm.startTime,
        this.contractForm.endTime,
        this.contractForm.serviceProviderCompanyId,
        this.contractForm.serviceProviderTransactorId,
        this.contractForm.clientCompanyId,
        this.contractForm.clientTransactorId,
        this.contractForm.services
      );
      if (res.success) {
        this.dialogFormVisible = false;
        this.initData();
        this.$message.success("添加成功");
        this.tableData = await this.contractHttpSet.getListElectricOperationsContractForClient();
      }
    },
    initData () {
      this.contractForm = {
        name: "",
        signingTime: "",
        startTime: "",
        endTime: "",
        serviceProviderCompanyId: "",
        serviceProviderTransactorId: "",
        clientCompanyId: "",
        clientTransactorId: "",
        services: [{ type: "", params: { measures: [], cycle: "", times: "" } }]
      };
    },
    addTaskType () {
      this.contractForm.services.push({
        type: "",
        params: { measures: [], cycle: "", times: "" }
      });
    },
    changeType (i) {
      console.log(i);
    },
    handleClose (done) {
      done();
    },
    openDetails (detail) {
      this.detailDrawerVisible = true;
      this.$nextTick(() => {
        this.$refs.detailDrawer.init(detail)
      })
      // this.detail = detail;
      // this.detail.services.forEach(item => {
      //   item.params = JSON.parse(item.params);
      // });
      // console.log(this.detail);

      // this.detail.params = JSON.parse(this.detail.params);
    },
    async changeCompany (id) {
      if (id == this.contractForm.clientCompanyId) {
        this.contractForm.serviceProviderCompanyId = "";
        this.$message.error("不能与客户公司重复");
        return;
      }

      this.serversList = await this.contractHttpSet.getListAllUserByCompany(id);
      this.contractForm.serviceProviderTransactorId = "";
    },
    async changeClient (id) {
      if (id == this.contractForm.serviceProviderCompanyId) {
        this.contractForm.clientCompanyId = "";
        this.$message.error("不能与服务提供方公司重复");
        return;
      }
      this.clientServersList = await this.contractHttpSet.getListAllUserByCompany(
        id
      );
      this.contractForm.clientTransactorId = "";
    }
  },
  async created () {
    this.contractHttpSet = new contractHttpSet(this);
    this.tableData = await this.contractHttpSet.getListElectricOperationsContractForClient();
    // 获取所有公司
    this.allCompany = await this.contractHttpSet.getListAllCompany();
    //获取公司维保客户
    this.clientList = await this.contractHttpSet.getListClientsForElectricOperationsCompany();
    //获取测量点
    this.measureList = await this.contractHttpSet.getcompanyFrontEndPageDefaultParam();
    console.log(this.tableData);
  },
  mounted () { },
  beforeCreate () { },
  beforeMount () { },
  beforeUpdate () { },
  updated () { },
  beforeDestroy () { },
  destroyed () { },
  activated () { }
};
</script>
<style lang="scss" scoped>
.ele-wrap {
  padding: 14px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  box-sizing: border-box;
  .wraps {
    width: 100%;
    height: 100%;
    background: #fff;
    padding: 14px;
    box-sizing: border-box;
  }
  .select-box {
    display: flex;
    align-items: center;
    .select-margin {
      margin-right: 10px;
    }
  }
  .table-box {
    margin-top: 30px;
  }
}

.drawer-main {
  color: #333;
  padding: 20px 30px 30px 30px;
  .drawer-header {
    display: flex;
    margin-bottom: 40px;
    .headbox {
      color: #999999;
      margin-right: 10px;
      .title {
        margin-right: 10px;
      }
      .satus {
        display: inline-block;
        padding: 8px;
        background: #f7eee9;
        border-radius: 4px;
        color: #fda32b;
      }
      .month {
        font-size: 24px;
        color: #333;
      }
    }
  }
  .drawer-cent {
    div {
      text-align: left;
    }
    .title {
      font-size: 18px;
    }
    .detailbox {
      margin-top: 15px;
      .label {
        color: #999999;
        display: inline-block;
        width: 100px;
        text-align: right;
        margin-right: 12px;
      }
    }
  }
}
.title-s {
  text-align: left;
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 10px;
}
::v-deep .el-input input {
  height: 30px;
}
::v-deep .el-select {
  width: 100%;
}
::v-deep .el-input__inner {
  height: 30px;
  width: 100%;
}
::v-deep .el-date-editor .el-range-separator {
  line-height: 25px;
}
::v-deep .el-date-editor .el-range__icon {
  line-height: 25px;
}
::v-deep th {
  background: #ecf1f8;
}
::v-deep .el-checkbox-group {
  display: flex;
  flex-wrap: wrap;
}
::v-deep .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
.operatiing {
  color: cornflowerblue;
  cursor: pointer;
}
.ts {
  text-align: left;
  line-height: 25px;
  width: 100%;
}
::v-deep .el-date-editor .el-range__close-icon {
  line-height: 25px;
}
</style>
